import React from 'react';
import styled from 'styled-components';
import { Button } from '../Inputs/Button.span';
import { withAmp } from '../AMP/AmpContext';

const Accordian = styled.div`
  .accordian__content {
    overflow: hidden;
    height: ${props => props.show === true ? '100%' : (props.height || '640px')};
    @media(max-width: 45em) {
      height: ${props => props.show === true ? '100%' : (props.height || '720px')};
    }
  }
  .accordian__handle {
    color: ${props => props.theme.colors.brand['500']};
    font-weight: 500;
    border-top: 1px solid ${props => props.theme.colors.white['500']};
    padding-top: 0.75em;
    box-shadow: ${props => props.show === true ? 'none' : '0 -12px 180px white, 0 -12px 130px white, 0 -12px 100px white'};
    position: relative;
    z-index: 100;
    &:hover {
      cursor: pointer;
    }
  }
`;

class ContentAccordian extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.show != null ? props.show : false,
    };
  }

  handleToggle() {
    this.setState(prevState => ({ ...prevState, show: !prevState.show }))
  }

  render() {
    const { amp } = this.props;

    return amp === true ? (
      <div>
        {this.props.children}
      </div>
    ) : (
      <Accordian height={this.props.height} show={this.state.show}>
        <div className="accordian__content">
          {this.props.children}
        </div>
        <div className="accordian__handle" onClick={() => this.handleToggle()}>
          <Button size="sm" inverted>{this.state.show === false ? 'Read More +' : 'Collapse -'}</Button>
        </div>
      </Accordian>
    );
  }
}

export default withAmp(ContentAccordian);
